import type { ReactNode } from "react";
import { useMemo } from "react";
import { I18nProvider, createI18nHttpClient } from "@expertloop/i18n/react";
import { ADMIN_API_BASE_URL } from "../../services/config";

interface AppI18nProviderProps {
	children: ReactNode;
}

// Câblage du moteur i18n partagé sur l'Admin : même API i18n que le Web,
// préférence conservée en localStorage (pas de préférence compte admin).
export function AppI18nProvider({ children }: AppI18nProviderProps) {
	const client = useMemo(() => createI18nHttpClient(ADMIN_API_BASE_URL), []);

	return <I18nProvider client={client}>{children}</I18nProvider>;
}
